module.exports = require("./nl.d.ts");